import { render, staticRenderFns } from "./OrgPost.vue?vue&type=template&id=1b16b990&scoped=true&"
import script from "./OrgPost.vue?vue&type=script&lang=js&"
export * from "./OrgPost.vue?vue&type=script&lang=js&"
import style0 from "./OrgPost.vue?vue&type=style&index=0&id=1b16b990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16b990",
  null
  
)

export default component.exports